import { useHandlers } from '@sparklayer-io/spark-dash-pages/context/page-context';
import type { CustomersSyncApiContract } from '../api';

export function useCustomersSyncApi(): { customersSyncApi: CustomersSyncApiContract } {
  const { apis } = useHandlers();
  if (!apis.customersSync) {
    throw new Error(
      'apis.customersSync is missing. Mount this page with `buildApis` from @sparklayer-io/dashboard.',
    );
  }
  return { customersSyncApi: apis.customersSync };
}
